/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { parallax } from './parallax';

export function filter() {
  // first, check to see if the URL has something in to pre-filter
  if (window.location.search.length) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const filterPreference = urlParams.get('filter');
    const container = $('.filterContainer');
    var products = $('.product');

    // If the filter param exists, do stuff
    if (location.search.indexOf('filter=') >= 0 ) {

      // hide all the products
      container.addClass('hiding');
      products.hide();

      // show the products that fit the filter
      $(".product.product_cat-" + filterPreference).show();
      setTimeout(function() {
        container.removeClass('hiding');
      }, 1000);

      // set the active filter item
      if (window.innerWidth <= 960) {
        $(".filter__listItem").removeClass('filter__listItem--active');
        var chosenFilter = $('.filter__listItem[data-filter-id=' + filterPreference).text();
        $('.filter__activeFilter--inner').text(chosenFilter);
      } else {
        $(".filter__listItem").removeClass('filter__listItem--active');
        $(".filter__listItem[data-filter-id='" + filterPreference + "']").addClass('filter__listItem--active');
      }

      // filter the products
      if (!$('.product').hasClass('.product_cat-' + filterPreference)) {
        $(this).hide();
      }

      // scroll to the section
      // setTimeout(function() {
      //   locoScroll.scrollTo($(".products").offset().top - 221);
      // }, 1500);
    }
  }

  // Otherwise, do stuff when filters are selected
  const selectEl = document.querySelector('.customSelect');
  const filterEl = document.querySelector('.filter__activeFilter');
  const container = $('.filterContainer');
  var products = $('.product');

  const elSelectCustomValue = selectEl.children[0];
  const elSelectCustomOptions = selectEl.children[1];
  const defaultLabel = elSelectCustomValue.getAttribute("data-filter-value");

  $('.filter__listItem').on('click tap', function () {
    var chosenFilter = $(this).attr('data-filter-id');
    var chosenFilterText = $(this).text();
    $('.filter__listItem').removeClass('filter__listItem--active');
    $(this).addClass('filter__listItem--active');

    // slide to top of section
    // setTimeout(function () {
    //   locoScroll.scrollTo(document.querySelector('.products'));
    // }, 500);

    // setTimeout(function() {
    //   locoScroll.update();
    // }, 2000);

    if (chosenFilter === 'all') {
      container.addClass('hiding');
      setTimeout(function() {
        products.show();
      }, 550);
      setTimeout(function() {
        container.removeClass('hiding');
      }, 600);
      // Update the URL
      var uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
      }
    } else {
      // fade out if don't have that class
      container.addClass('hiding');
      setTimeout(function() {
        products.hide();
        $(".product.product_cat-" + chosenFilter).show();
      }, 550);

      // fade in if you do have that class
      setTimeout(function() {
        container.removeClass('hiding');
      }, 600);

      // Update the URL
      if (history.pushState) {
        history.pushState(null, null, "?filter=" + chosenFilter);
      } else {
        location.hash = "?filter=" + chosenFilter;
      }

      // Reset parallax
      setTimeout(() => {
        parallax();
      }, 1000);
    }

    // set the activeFilter value
    $('.filter__activeFilter--inner').text(chosenFilterText);

    // remove the open class
    selectEl.classList.remove("open");

  });

  // Open the filter on click
  filterEl.addEventListener("click", function () {
    selectEl.classList.toggle("open");
    document.querySelector('.filter__activeFilter').classList.toggle('open');
  });

  // close the custom select when clicking outside.
  document.addEventListener("click", function () {
    const didClickedOutside = !filterEl.contains(event.target);
    if (didClickedOutside) {
      selectEl.classList.remove("open");
    }
  });

  // reset parallax
  parallax();
}

